export const NODE_MODULE_PATH = "./node_modules/integral-generator/dist";
